import React, { useEffect, useState } from "react";
import { useGlobalDataContext } from "../../../GlobalDataContext";
import { useTranslation } from "react-i18next";

import { getFloor } from "./../../utils/helpers";

const JackPotLogo = () => {
  const { state } = useGlobalDataContext();
  const { t } = useTranslation();

  const [jackpotShadow, makeJackpotShadow] = useState(false);
  const [superJackpotShadow, makeSuperJackpotShadow] = useState(false);
  const [outerEllipseMove, makeOuterEllipseMove] = useState(false);

  // jackpot and super jackpot shadow animation
  useEffect(() => {
    setTimeout(() => {
      makeSuperJackpotAnimate();
    }, 11000);
    // eslint-disable-next-line
  }, []);

  const makeJackpotAnimate = () => {
    makeJackpotShadow(true);
    const jackpotShadowTimeout = setTimeout(() => {
      makeJackpotShadow(false);
    }, 2000);
    const outerEllipseMoveTimeout = setTimeout(() => {
      makeOuterEllipseMove(true);
    }, 6000);
    const superJackpotShadowTimeout = setTimeout(() => {
      makeSuperJackpotAnimate();
    }, 12000);
    return () => {
      clearTimeout(jackpotShadowTimeout);
      clearTimeout(superJackpotShadowTimeout);
      clearTimeout(outerEllipseMoveTimeout);
    };
  };

  const makeSuperJackpotAnimate = () => {
    makeOuterEllipseMove(true);
    makeSuperJackpotShadow(true);
    const superJackpotShadowTimeout = setTimeout(() => {
      makeSuperJackpotShadow(false);
      makeOuterEllipseMove(false);
    }, 2000);
    const jackpotShadowTimeout = setTimeout(() => {
      makeJackpotAnimate();
    }, 2000);
    return () => {
      clearTimeout(jackpotShadowTimeout);
      clearTimeout(superJackpotShadowTimeout);
    };
  };

  return (
    <>
      {state.jackPotStatus.superJackPot && (
        <div
          className={`logo align-center ${
            state.jackPotStatus.jackPot === 0 ? "fullH" : ""
          }`}
        >
          <div
            className={
              !outerEllipseMove
                ? "outer-ellipse"
                : "outer-ellipse outer-ellipse-move"
            }
          >
            <span
              className={
                !superJackpotShadow
                  ? `super-jackpot`
                  : `super-jackpot super-jackpot-label-text-shadow`
              }
            >
              {t("header.jackpot.superjackpot")}:{" "}
              {getFloor(state.jackPotStatus.superJackPot, 100)}{" "}
              {state.appSettings.currency}
            </span>
          </div>
        </div>
      )}

      {state.jackPotStatus.Jackpot !== 0 && (
        <div
          className={`logo ${
            !state.jackPotStatus.superJackPot ? "fullH" : ""
          }`}
        >
          <span
            className={
              !jackpotShadow ? `jackpot` : `jackpot jackpot-label-text-shadow`
            }
          >
            {t("header.jackpot.jackpot")}:{" "}
            {getFloor(state.jackPotStatus.Jackpot, 100)}{" "}
            {state.appSettings.currency}
          </span>
        </div>
      )}
    </>
  );
};

export default JackPotLogo;
